import { Injectable } from '@angular/core';

export interface NotificationOption {
  email: boolean;
  push: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PendingNotificationPreferencesService {
  private readonly pendingPreferences = new Map<string, NotificationOption>();

  /**
   * Add a pending preference for a specific group
   * @param groupId - The unique identifier for the notification group
   * @param notificationOption - The notification preferences to store
   */
  addPendingPreference(
    groupId: string,
    notificationOption: NotificationOption,
  ): void {
    this.pendingPreferences.set(groupId, { ...notificationOption });
  }

  /**
   * Retrieve a stored pending preference for a specific group
   * @param groupId - The unique identifier for the notification group
   * @returns The stored notification preference or undefined if not found
   */
  getPendingPreference(groupId: string): NotificationOption | undefined {
    const preference = this.pendingPreferences.get(groupId);
    return preference ? { ...preference } : undefined;
  }

  /**
   * Clear a stored pending preference for a specific group
   * @param groupId - The unique identifier for the notification group
   * @returns true if the preference was removed, false if it didn't exist
   */
  clearPendingPreference(groupId: string): boolean {
    return this.pendingPreferences.delete(groupId);
  }

  /**
   * Clear all pending preferences
   */
  clearAllPendingPreferences(): void {
    this.pendingPreferences.clear();
  }
}
